import Swal from 'sweetalert2';

const PYODIDE_ERROR_HTML_BODY = `
  <div>
    <p>
      <strong>Here are some potential solutions to the problem</strong>
    </p>
    <ul>
      <li>
        <p>
          Try refreshing the page.
        </p>
      </li>
      <li>
        <p>
          Check your internet connection. If your internet connection is slow or
          cutting out, please wait or try a different connection.
        </p>
      </li>
      <li>
        <p>
          Check to see if any browser extensions (ad blockers for example) could
          be causing the issue.
        </p>
      </li>
      <li>
        <p>
          If you use Internet Download Manager, you may need to follow these
          steps:
        </p>
        <p>
          Open IDM -> Options -> File Types -> Edit List
        </p>
        <p>
          Then add:
          <b>https://codeinplace.stanford.edu/pyodide/build/pyodide_py.tar</b>
        </p>
      </li>
    </ul>
    <p>
      If none of those work, please email codeinplace@stanford.edu and we
      can work to solve this issue!
    </p>
  </div>
`;

export async function showPyodideErrorReloadSwal(): Promise<void> {
  const result = await Swal.fire({
    title: 'Uh Oh! Something went wrong.',
    confirmButtonText: 'Reload Page',
    html: PYODIDE_ERROR_HTML_BODY,
  });
  if (result.isConfirmed) {
    document.location.reload();
  }
}
